module.exports = __webpack_public_path__ + "img/shape-23.db9dad74.png";